module.exports = function getResource(label, vars=[]) {
    const resources = {
        getItShippedTitle: 'Faites livrer',
        shippingAndReturns: 'Livraison et retours',
        reserveAndPickUp: 'Réservation et ramassage',
        buyOnlineAndPickUp: 'Achat en ligne et ramassage',
        selectForStoreAvailability: 'Sélectionner pour voir la disponibilité',
        limitedStock: 'Quantités limitées',
        outOfStock: 'Rupture de stock',
        inStock: 'En stock',
        stores: 'magasins',
        nearYou: 'près de chez vous',
        checkOtherStores: 'Voir les autres magasins',
        freeShippingMessage: `Plus que ${vars[0]} pour avoir droit à la livraison gratuite.`,
        shippingMessageSpend: 'Dépensez 50 $ pour bénéficier de la livraison gratuite.',
        notOffered: 'Réservation non offerte dans ce magasin',
        pickUpNotOffered: 'Le ramassage n’est pas offert dans ce magasin',
        atThisStore: 'dans ce magasin',
        availableInAllStores: 'Offert dans tous les magasins',
        onlineOnly: 'En ligne seulement',
        reserveNotAvailable: 'Option Réservation et ramassage non offerte',
        pickUpNotAvailable: 'Option Achat en ligne et ramassage non offerte',
        reservationNotOfferedForItem: 'Réservation non offerte pour cet article',
        pickUpNotOfferedForItem: 'Le ramassage n’est pas offert pour cet article',
        at: 'à',
        for: 'pour',
        sameDayDelivery: 'Livraison le jour même',
        standard: 'Standard',
        sameDayDeliveryNotAvailable: 'Non disponible pour cet article',
        sddTemporarilyUnavailableAtLocation: 'La livraison le jour même n’est pas disponible pour le moment. Veuillez réessayer plus tard.',
        sameDayNotAvailableFor: 'La livraison le jour même n’est pas disponible',
        yourLocation: 'votre emplacement',
        changeLocation: 'Changer votre emplacement',
        autoReplenishTitle: 'Réapprovisionnement automatique',
        deliveryEvery: 'Livraison chaque',
        months: 'mois',
        mostCommon: 'le plus courant',
        subscriptionNotAvailable: 'Non disponible pour cette sélection',
        save: 'Sauvegarder',
        rougeMemberYouGet: 'En tant que membre Rouge, vous pouvez aussi essayer',
        rougeMemberFreeSameDayDelivery: 'gratuitement la livraison le jour même',
        autoReplenishLegalOptIn: 'En vous inscrivant, vous consentez aux frais récurrents de votre abonnement.',
        freeShipSignIn: `${vars[0]} or ${vars[1]} to enjoy ${vars[2]}.`,
        signIn: 'Sign in',
        createAccount: 'create an account',
        freeStandardShipping: 'FREE standard shipping'
    };

    return resources[label];
};
